import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { TGlobalOrder } from '@models/orders.class';
import { Subscription } from 'rxjs';
import { TradeService } from 'src/core/services/trade.service';
import { NotificationService } from 'src/core/services/notification.service';
import { AnalyticsTrackingService } from 'src/core/services/analyticsTracking.service';
import { AppState, OPERATION_RESET } from 'src/app';
import { TRACKING_EVENTS } from 'src/app/app.constants';

@Component({
  selector: 'hb-double-selling',
  templateUrl: './double-selling.component.html',
  styleUrls: ['./double-selling.component.scss'],
})
export class DoubleSellingComponent implements OnDestroy {
  @Input() public order: TGlobalOrder;
  @Output() public closeSideModal = new EventEmitter<void>();

  private subscriptions = new Subscription();

  constructor(
    private readonly tradeService: TradeService,
    private readonly notificationService: NotificationService,
    private readonly analyticsTrackingService: AnalyticsTrackingService,
    private readonly store: Store<AppState>,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public cancelCapitalMarketOrder(): void {
    this.subscriptions.add(
      this.tradeService.cancelUsaOrder(this.order.sobId).subscribe(
        () => {
          this.notificationService.showSuccess({
            title: 'Orden Cancelada',
            message:
              'Tu orden de venta fue cancelada con éxito, ya puedes ejecutar una nueva',
            eventId: undefined,
            isBusinessError: false,
          });

          this.analyticsTrackingService.logEvent(
            TRACKING_EVENTS.send_order_cancelation.event,
            {
              ...TRACKING_EVENTS.send_order_cancelation.success,
              Origin: this.analyticsTrackingService.processOrigin(
                window.location.pathname,
              ),
            },
          );

          this.store.dispatch({
            type: OPERATION_RESET,
            payload: { reset: true },
          });

          this.closeSideModal.emit();
        },
        (error) => {
          this.analyticsTrackingService.logEvent(
            TRACKING_EVENTS.send_order_cancelation.event,
            {
              ...TRACKING_EVENTS.send_order_cancelation.error,
              Origin: this.analyticsTrackingService.processOrigin(
                window.location.pathname,
              ),
              Callback: error.message || error.ErrorMessage,
            },
          );

          this.closeSideModal.emit();
        },
      ),
    );
  }
}
